export const environment = {
  uid: 'prod_igy',
  backendUri: 'https://rag.i.impactmindset.org'
};
